/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'

import DashboardPage from './DashBoardPage'
import DashBoardPageV2 from '../dashboard-v2/DashBoardPage'
import DashBoardPagePro from '../dashboard-pro/DashBoardPage'
import { ContactClosePopup, ContactStartUpload } from '../../../Components/PopupSlice/popupSlice'
import {
  systemNotification,
  portalNotification,
} from '../../../Redux/NotificationSlice/NotificationSlice'
import { useSocket } from '../../../Utils/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectedProfile,
  setSelectedDashboard,
} from '../../../Redux/FrontEnd/ProDashboardSlices/ProDashboardSlice'
import { getAllUserDetails } from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { DetailWalletCardReport } from '../detail-wallet-card-report/DetailWalletCardReport'

const DashboardWrapper: FC = () => {
  const dispatch = useDispatch()
  const userValues = useSelector(getAllUserDetails)
  const selectedDashboardProfile = useSelector(selectedProfile)

  useEffect(() => {
    if (selectedDashboardProfile === "" && userValues && userValues?.defaultDashboardProfile !== "") {
      dispatch(setSelectedDashboard(userValues?.defaultDashboardProfile))
    }
  }, [userValues])

  switch (selectedDashboardProfile) {
    case 'dashboard-2':
      return <DashBoardPageV2 />
    case 'dashboard-pro':
      return <DashBoardPagePro />
    case 'dashboard-leads':
      return <DetailWalletCardReport />
    default:
      return <DashboardPage />
  }
}

export { DashboardWrapper }
